import { createFileRoute } from "@tanstack/react-router";
import PiataExterna from "@/pages/PiataExterna";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/piata-externa/")({
  head: () => routeHead("/piata-externa/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PiataExterna />
  );
}
